module.exports = __webpack_public_path__ + "static/media/tt.96a752fc.svg";